import { switchMap } from "rxjs/operators";
export var guard = function (state$, deps, defaultPath) { return function (checks) {
    return switchMap(function (actionData) {
        var alteredPath = checks.find(function (check) { return check(actionData, state$, deps) != undefined; });
        return alteredPath
            ? alteredPath(actionData, state$, deps)(actionData, state$, deps)
            : defaultPath(actionData, state$, deps);
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/guards/guard.ts
// module id = 46
// module chunks = 3